var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTakeHandMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 201.756,
    height: 106.487
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Take_Hand_Mobile_svg__a",
    x: 0,
    y: 19.329,
    width: 176.289,
    height: 87.158,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Take_Hand_Mobile_svg__b",
    x: 150.377,
    y: 0,
    width: 51.379,
    height: 51.396,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Take_Hand"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.004)",
    filter: "url(#Take_Hand_Mobile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3848",
    d: "M118.902 65.742l52.891-26.1-14.929-18.812-48.277 26.34h-.1l-57.91 19.593a.616.616 0 01-.472 0A22.494 22.494 0 0039.61 64.35a.944.944 0 01-.261 0l-11.587-4.681a3.264 3.264 0 00-3.952 1.687 3.374 3.374 0 001.1 4.217l7.928 2.817h.067l.118.093a.143.143 0 01.051.051.481.481 0 01.1.152.667.667 0 010 .186 5.853 5.853 0 000 .717 6.967 6.967 0 00.784 2.581c.843 1.628 3.087 2.7 4.318 3.053a2.818 2.818 0 00.692.127.633.633 0 110 1.265c-1.181 0-4.791-1.349-6.132-3.854a8.089 8.089 0 01-.9-2.935A99.793 99.793 0 0116.03 75.23a70.084 70.084 0 00-9.952 3.458 2.218 2.218 0 00-1.451 2.851 2.589 2.589 0 003.264 1.619c1.451-.43 14.406-4.217 15.182-4.344a.624.624 0 01.708.413.633.633 0 01-.3.768c-2.817 1.476-7.591 3.88-11.066 5.642L7.91 87.966c-2.48 1.3-2.758 1.687-2.083 3.019 1.248 2.48 6.849-.16 7.076-.27l11.049-5.9a.633.633 0 01.843.27.624.624 0 01-.261.843L13.51 91.77c-2.016 1.139-4.1 2.437-4.327 3.466a1.071 1.071 0 00.261.843c1.493 2.05 4.5.751 7.237-.843l4.015-2.083h.051l8.038-5.187a.633.633 0 11.692 1.054l-8 5.288a.346.346 0 01-.093.1c-2.033 1.366-2.53 2.977-1.923 3.863s2.53 1.147 4.875-.38c3.028-1.957 6.064-4.166 9.176-6.435a.54.54 0 01.3-.118 57.354 57.354 0 008.873-2.4c7.144-2.53 10.189-5.136 12.415-7.591a.616.616 0 01.329-.186c14.439-3.289 50.453-11.808 61.274-14.566a11.191 11.191 0 002.21-.86z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1169",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.191 91.246h0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3849",
    d: "M13.242 91.22h-.051",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.004)",
    filter: "url(#Take_Hand_Mobile_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3850",
    d: "M193.458 8.189a17.636 17.636 0 00-24.768-2.876l-13.81 10.964 2.311 2.91.4.506.4.506 14.954 18.85.4.506.4.506 3.045 3.838 13.807-10.964a17.653 17.653 0 002.851-24.746z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3851",
    d: "M194.44 7.401a18.884 18.884 0 00-26.54-3.052l-14.338 11.352a.6.6 0 00-.236.422.641.641 0 00.135.464l2.53 3.239-48.075 26.204-57.504 19.449a23.54 23.54 0 00-10.712-2.37l-11.5-4.622a4.521 4.521 0 00-5.56 2.337 4.63 4.63 0 001.6 5.9.674.674 0 00.135.067l6.553 2.328a102.057 102.057 0 01-15.182 5.061 70.371 70.371 0 00-10.18 3.348 3.492 3.492 0 00-2.151 4.4 3.871 3.871 0 004.807 2.437l9.134-2.64-5.48 2.782-4.555 2.311C5.28 87.88 3.357 88.884 4.69 91.532c.843 1.687 2.674 1.9 4.462 1.687a3.627 3.627 0 00-1.2 1.8 2.286 2.286 0 00.472 1.9c2.362 3.247 6.924.658 8.856-.43l1-.523a3.087 3.087 0 00.135 2.96 3.188 3.188 0 002.764 1.323 7.3 7.3 0 003.838-1.316c3-1.948 6.022-4.133 9.1-6.385a59.331 59.331 0 008.974-2.429c7.27-2.53 10.475-5.263 12.795-7.8C70.46 78.996 106.221 70.511 117 67.787a12.936 12.936 0 002.454-.9l53.135-26.238 3.61 4.546a.633.633 0 00.5.245.658.658 0 00.4-.143l14.338-11.352a18.909 18.909 0 003.003-26.544zm-17.642 36.512l-3.045-3.838-.4-.506-.4-.506-14.963-18.842-.4-.506-.4-.506-2.311-2.935L168.684 5.31a17.634 17.634 0 0121.929 27.622zM55.084 81.31c-2.227 2.471-5.271 5.061-12.415 7.591a57.35 57.35 0 01-8.873 2.437.54.54 0 00-.3.118c-3.112 2.269-6.149 4.479-9.176 6.435-2.362 1.527-4.217 1.349-4.875.38s-.11-2.53 1.923-3.863a.346.346 0 00.093-.1l8-5.288a.633.633 0 10-.692-1.054l-8.029 5.305h-.051l-4.006 2.078c-2.741 1.552-5.744 2.851-7.237.843a1.071 1.071 0 01-.261-.843c.228-1.029 2.311-2.328 4.327-3.466l11.028-5.841a.624.624 0 00.261-.843.633.633 0 00-.843-.27l-11.049 5.9c-.228.11-5.828 2.75-7.076.27-.675-1.324-.4-1.687 2.083-3.019l4.538-2.3c3.441-1.906 8.24-4.31 11.032-5.786a.633.633 0 00.3-.768.624.624 0 00-.708-.413c-.843.152-13.765 3.913-15.182 4.344a2.589 2.589 0 01-3.264-1.619 2.218 2.218 0 011.442-2.851 70.089 70.089 0 0110.066-3.264 99.792 99.792 0 0015.9-5.406 8.088 8.088 0 00.9 2.935c1.341 2.53 4.951 3.854 6.132 3.854a.633.633 0 100-1.265 2.817 2.817 0 01-.692-.127c-1.231-.354-3.45-1.425-4.318-3.053a6.967 6.967 0 01-.784-2.581 5.853 5.853 0 010-.717.666.666 0 000-.186.481.481 0 00-.1-.152.144.144 0 00-.051-.051l-.118-.093h-.069l-7.928-2.817a3.374 3.374 0 01-1.1-4.217 3.264 3.264 0 013.956-1.687l11.478 4.489a.944.944 0 00.261 0A22.494 22.494 0 0150.1 66.702a.616.616 0 00.472 0l57.909-19.553h.1l48.279-26.32 14.929 18.808-52.892 26.146a11.192 11.192 0 01-2.21.843c-10.821 2.674-46.818 11.217-61.274 14.5a.616.616 0 00-.329.186zm-41.893 9.939z"
  }))));
}

export default __webpack_public_path__ + "static/media/Take_Hand_Mobile.d540967643c5dfe38d0674b3d2ce2f8d.svg";
export { SvgTakeHandMobile as ReactComponent };